import api from './client'

export interface IncludedServiceItem {
  id: string
  companyId: string
  textEn: string | null
  textIt: string | null
  sortOrder: number
  isActive: boolean
  createdAt: string
  updatedAt: string
}

const base = (cid: string) => `/companies/${cid}/included-services`

export const includedServicesApi = {
  list: (cid: string, opts?: { includeInactive?: boolean }) =>
    api.get<IncludedServiceItem[]>(base(cid), {
      params: { includeInactive: opts?.includeInactive ? 'true' : undefined },
    }).then(r => r.data),

  create: (cid: string, dto: { textEn?: string; textIt?: string; sortOrder?: number }) =>
    api.post<IncludedServiceItem>(base(cid), dto).then(r => r.data),

  update: (cid: string, id: string, dto: { textEn?: string; textIt?: string; sortOrder?: number; isActive?: boolean }) =>
    api.patch<IncludedServiceItem>(`${base(cid)}/${id}`, dto).then(r => r.data),

  remove: (cid: string, id: string) => api.delete(`${base(cid)}/${id}`),
}
